import CustomTable from 'designer/component/element/Table'
import { makeUppercaseFirst } from 'designer/menu/converter/Design'
import objectPath from 'object-path'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

const Table = (props) => {
  const { chart, dataSource } = props
  const value = objectPath.get(chart, 'value')
  const apiKey = objectPath.get(dataSource, 'apiKey') || ''
  const responseKey = objectPath.get(dataSource, 'responseKey') || ''
  const tableKey = `${apiKey}${makeUppercaseFirst(responseKey)}`
  const tableName = responseKey
  const options = objectPath.get(chart, 'options') || {}
  const { columnRefId = '' } = options
  const loadData = { method: 'JSON', columnRefId: columnRefId }
  const uischema = {
    key: tableKey,
    name: tableName,
    loadData,
    isPaging: true,
    ...options,
  }
  const [tableData, setTableData] = useState([])
  const updateData = (tableData) => {
    setTableData(tableData)
  }

  useEffect(() => {
    updateData(value)
  }, [JSON.stringify(value)])

  return (
    <Row className="w-100 mx-auto">
      <Col>
        <CustomTable
          fieldName={tableName}
          fieldKey={tableKey}
          config={{}}
          title={''}
          uischema={uischema}
          isChart={true}
          chartData={tableData}
          updateData={updateData}
        />
      </Col>
    </Row>
  )
}

export default Table
